
const mixins = {
    methods: {
        tierNameById(tierId){
            if(tierId === '4')
                return 'Interim Tier 4'
            else if(tierId === '5')
                return 'Tier 4 Final'
            else
                return 'Tier '+tierId
        },
    }
};

export default mixins;
